import React from 'react';
import Skeleton from '../../atoms/Skeleton';
import './productCard.css';

/* ProductCardSkeleton — the shape of `.sf-prod` while it loads.
   It reuses the card's own classes rather than redrawing its geometry in
   Tailwind, so the card cannot change shape without its skeleton following. */
export default function ProductCardSkeleton() {
  return (
    <div className="sf-prod" aria-hidden="true">
      <span className="sf-pimg"><Skeleton w="100%" h="100%" /></span>
      <div className="sf-pb">
        <Skeleton w="42%" h={10} />
        {/* Two lines, the second short — `.sf-pname` clamps to two. */}
        <span style={{ display: 'block', margin: '7px 0 10px' }}>
          <Skeleton w="100%" h={12} />
          <span style={{ display: 'block', marginTop: 6 }}>
            <Skeleton w="64%" h={12} />
          </span>
        </span>
        <div className="sf-pfoot"><Skeleton w={62} h={14} /></div>
      </div>
    </div>
  );
}
